import React from 'react'
import ReactDOM from 'react-dom'
import './index.css'
import App from './App'
import registerServiceWorker from './registerServiceWorker'
import { Provider as StyletronProvider } from "styletron-react"
import { Client as Styletron } from "styletron-engine-atomic"
import ReactBreakpoints from 'react-breakpoints'
import { media } from './style'
import { BrowserRouter } from 'react-router-dom'
import Analytics from 'react-router-ga'
import BlogProvider from './providers/Blog'

// 1. Create a client engine instance
const engine =  new Styletron({
  hydrate: document.getElementsByClassName("_styletron_hydrate_")
})

ReactDOM.hydrate(
  <BrowserRouter>
    <Analytics id="UA-115470729-1">
      <ReactBreakpoints breakpoints={media.breakpoints}>
        <StyletronProvider value={engine}>
          <BlogProvider>
            <App />
          </BlogProvider>
        </StyletronProvider>
      </ReactBreakpoints>
    </Analytics>
  </BrowserRouter>
  , document.getElementById('root'))
registerServiceWorker()



// WEBPACK FOOTER //
// ./src/index.js